import React, { useState, useEffect, useLayoutEffect, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useRenderClassComponent from '../../hooks/useRenderClassComponent';
import TableComponent from '../oldGenericComponents/TableComponent';
import { useParams } from 'react-router-dom';
import { dispatchHandler, handleApiChange } from '../../helper/apiHelperFunctions';
import { v4 as uuidv4 } from 'uuid';
import { displayNamesForNewSubmitApi } from '../oldGenericComponents/tableHelperComponents/DisplayNameForNewServer'
import NoPageAvailable from './NoPageAvailable';
import TableFullPageLoader from './TableFullPageLoader';
import { getCurrentPageModuleCode, getMenuMode, isCurrentPageIsInReports, useIsKeyPresentInTheUrl } from '../../helper/helperTableFunctions';
import { UserDetailsContext } from '../../App';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { m } from 'framer-motion';

export default function GenericTableComponent(props) {

    // Function  :To check if the new menu is enabled or not
    const isNewMenuEnabled = () => {
        // Check if current page is in reports and anaytics
        let isCurrentPageIsInReportsCheck = isCurrentPageIsInReports?.();

        if (!isCurrentPageIsInReportsCheck) {
            return getMenuMode?.() == "new";
        } else return false;
    }

    const { apiName = "getTableComponentList", storeName = "generalStore", expandFirstProps = {}, summaryApiName = "getTableComponentSummary", tableHeadersMapRef, currentTab, tabsDataRef } = props;

    let { userDetails } = useContext(UserDetailsContext)
    const params = useParams()
    const dispatch = useDispatch();
    const generalStore = useSelector(state => state.generalStore);
    const states = {
        administrationStore: useSelector(state => state.administrationStore),
        masterDbStore: useSelector(state => state.masterDbStore),
        generalStore: useSelector(state => state.generalStore),
    }

    const [headersData, setHeadersData] = useState({});
    const [headersType, setHeadersType] = useState({});

    const [itemExpandedRow, setItemExpandedRow] = useState({})
    const [mainExpandedRow, setMainExpandedRow] = useState({})
    const [itemExpandedData, setItemExpandedData] = useState({})
    const [mainExpandedData, setMainExpandedData] = useState({})
    const [mainExpandLoading, setMainExpandLoading] = useState({});
    const [itemExpandLoading, setItemExpandLoading] = useState({});

    const [tabsLoading, setTabsLoading] = useState(true);

    const [filteredTabs, setFilteredTabs] = useState(props.actionBarConfig?.tabs?.key ? JSON.parse(JSON.stringify(props.actionBarConfig?.tabs?.data || "{}")) : {});
    const [tabsDisplayNameMapping, setTabsDisplayNameMapping] = useState({});

    const [bit, setBit] = useState(false);
    const [prevTabsData, setPrevTabsData] = useState({});
    const [headersResponse, setHeadersResponse] = useState({});

    const [expandAll, setExpandAll] = useState({});
    const location = useLocation();
    const [tableHeadersMap, setTableHeadersMap] = useState({});
    // const [updateFilteredTabs, setUpdateFilteredTabs] = useState(false);

    // Get the response of this api
    const getTabsConfigurationForModuleCodeData = useSelector(state => state?.generalStore?.getTabsConfigurationForModuleCodeData);

    useEffect(() => { if (tableHeadersMapRef) if (tableHeadersMapRef) tableHeadersMapRef.current = tableHeadersMap }, [tableHeadersMap])
    useEffect(() => { if (tabsDataRef) if (tabsDataRef) tabsDataRef.current = filteredTabs }, [filteredTabs])

    const {isKeyPresentInTheUrl} = useIsKeyPresentInTheUrl();

    // The Display Name Mapping to reverse map the display name with the level of headers
    let displayNameLevelReverseMapping = {
        "MAIN": "main",
        "ITEM": "item",
        "DETAIL": "detail",
        "DETAILS": "details",
        "ASN": "asn",
        "ITEMS": "items",
        "SET": "set",
        "SETS": "set",
        "SETUDF": "setudf",
        "CATDESC": "catdesc",
        "ITEMUDF": "itemudf",
        "LINEITEM": "lineitem",
    }

    const getDisplayNameLevelReverseMapping = (level) => {
        return displayNameLevelReverseMapping?.[level] || "";
    }

    // Handle the response of the get tabs configuration for the module code data
    useEffect(() => {
        if (getTabsConfigurationForModuleCodeData?.isSuccess) {

            // Get the data from the tabs configuration response is set up from the redux of getTabsConfigurationForModuleCodeData
            let data = getTabsConfigurationForModuleCodeData?.data?.resource || {};
            console.log("this is the data of tabs", data)
            let tabsObject = {};
            let tableHeaders = {};

            // Function : To update the display name into the table headers 
            const updateTableHeadersIntoTheObject = (displayNames = []) => {
                let obj = {};
                displayNames?.forEach(item => {
                    if (item?.["display_name_type"] && item?.["display_name"] && item?.["api_url"]) {
                        obj[getDisplayNameLevelReverseMapping(item?.display_name_type)] = {
                            name: item?.display_name_type || "",
                            key: item?.display_name || "",
                            apiUrl: item?.api_url || "",
                        }
                    }
                })
                return obj;
            }

            data?.tabs?.forEach(item => {
                tabsObject[item.tab_key_frontend] = item.tab_name;
                if (data?.tabs?.length > 1) {
                    if (!tableHeaders?.[item?.tab_key_frontend]) {
                        tableHeaders[item.tab_key_frontend] = updateTableHeadersIntoTheObject(item?.display_names) || {}
                    }
                } else {
                    tableHeaders = updateTableHeadersIntoTheObject?.(item?.display_names)
                }
            })
            if (tableHeadersMapRef)
                tableHeadersMapRef.current = tableHeaders
            setTableHeadersMap(tableHeaders);
            setTabsLoading(false);
            setFilteredTabs(tabsObject);

            // Case : If the user is at the page and he refreshed it should come to the same page and tab.
            let currentTabPresentInTheUrl = props?.actionBarConfig?.tabs?.key ? isKeyPresentInTheUrl({key : props?.actionBarConfig?.tabs?.key}) : false;
        
            if (!currentTabPresentInTheUrl || !tabsObject?.[currentTabPresentInTheUrl]) {
                if (data?.default_tab_name && data.default_tab_name != currentTab && tabsObject?.[data.default_tab_name]) {
                    props.setCurrentTab?.(data?.default_tab_name)
                } else {
                    if (!Object.keys(tabsObject || {})?.includes(currentTab)) {
                        props?.setCurrentTab?.(Object.keys(tabsObject || {})?.[0])
                    }
                }
            }
        }
        if (getTabsConfigurationForModuleCodeData?.isError) {
            setTableHeadersMap({});
            props?.setCurrentTab?.("");
            setTabsLoading(false);
            setFilteredTabs({});
        }
    }, [getTabsConfigurationForModuleCodeData])


    useEffect(() => {
        if (!isNewMenuEnabled?.()) {
            if (JSON.stringify(props.actionBarConfig?.tabs?.data) != JSON.stringify(prevTabsData)) {
                setPrevTabsData(props.actionBarConfig?.tabs?.data)
                setFilteredTabs(JSON.parse(JSON.stringify(props.actionBarConfig?.tabs?.data || "{}")) || {})
                updateCurrentTabOnFilteredTabs({
                    filteredTabsData: JSON.parse(JSON.stringify(props.actionBarConfig?.tabs?.data || "{}")) || {}
                })
                getTabsData({
                    filteredTabsData: JSON.parse(JSON.stringify(props.actionBarConfig?.tabs?.data || "{}")) || {}
                });
            }
        }
    }, [props.actionBarConfig?.tabs?.data])
    // Get the tabs data in case when the new main menu is on
    useEffect(() => {
        if (isNewMenuEnabled?.()) {
            getTabsFromMainMenu();
        }
    }, [])

    // Function : To get the tabs from the main menu coniguration
    const getTabsFromMainMenu = () => {

        // get the current page module
        let { moduleCode, activeModule } = getCurrentPageModuleCode?.({
            userDetails,
            location
        })

        console.log('moduleCode is ===', moduleCode, 'activeModule is ===', activeModule);

        handleApiChange(dispatch, "getTabsConfigurationForModuleCodeRequest", {
            activeModule: activeModule,
            moduleCode: moduleCode
        })
    }

    const getTabsData = ({
        filteredTabsData = JSON.parse(JSON.stringify(filteredTabs))
    }) => {
        if (!getTableHeadersMap?.()) {
            return
        }
        let requestId = uuidv4()
        if (props.actionBarConfig?.tabs?.key && Object.keys(getTableHeadersMap?.() || {})?.length > 0) {
            let obj = {};
            setHeadersResponse({});
            setTabsLoading(requestId);
            Object.keys(getTableHeadersMap?.() || {})?.map(item => {
                if (filteredTabsData?.[item]) {
                    obj[getTableHeadersMap?.()?.[item]?.main?.key] = item;
                    handleApiChange(dispatch, "getHeadersRequest", {
                        enterpriseName: "TURNINGCLOUD",
                        displayName: getTableHeadersMap?.()?.[item]?.main?.key,
                        basedOn: "main",
                        requestId: requestId
                    })
                }
            })
            setTabsDisplayNameMapping(obj);;
        } else if (typeof (getTableHeadersMap?.()) == "function" ? getTableHeadersMap?.()?.()?.main?.key : getTableHeadersMap?.()?.main?.key) {
            setTabsLoading(requestId);
            handleApiChange(dispatch, "getHeadersRequest", {
                enterpriseName: "TURNINGCLOUD",
                displayName: typeof (getTableHeadersMap?.()) == "function" ? getTableHeadersMap?.()?.()?.main?.key : getTableHeadersMap?.()?.main?.key,
                basedOn: "main",
                requestId: requestId
            })
        } else {
            setTabsLoading(false);
        }
    }

    useEffect(() => {
        if (generalStore?.getHeadersData?.isSuccess && generalStore?.getHeadersData?.data?.basedOn !== "main") {
            let data = generalStore?.getHeadersData?.data?.resource || {};
            setHeadersData(updatedHeadersData => {
                updatedHeadersData[`${generalStore?.getHeadersData?.data?.basedOn}`] = data;
                return updatedHeadersData
            })

            setHeadersType(updatedHeadersType => {
                updatedHeadersType[`${generalStore?.getHeadersData?.data?.basedOn}`] = Object.keys(data?.["Custom Headers"] || {})?.length > 0 ? "Custom Headers" : "Default Headers"
                return updatedHeadersType;
            })
            setBit(!bit);
        } else {
            // Main level data render and is called friom this page
            if (tabsLoading === generalStore?.getHeadersData?.data?.requestId) {
                let data = generalStore?.getHeadersData?.data?.resource || {};
                let displayName = generalStore?.getHeadersData?.data?.resource?.displayName || "";
                setHeadersResponse(prev => {
                    prev[displayName] = data?.["isDisplay"];
                    if (Object.keys(prev || {})?.length == Object.keys(tabsDisplayNameMapping || {})?.length && Object.keys(prev || {})?.length > 0) {
                        setTabsLoading(false);

                    } else if (!props.actionBarConfig?.tabs?.key) {
                        // Case:  when not tab is present on the page.
                        setTabsLoading(false);
                    }
                    return prev;
                })
                // This should run only when user has some tabs available on the page.
                if (props?.actionBarConfig?.tabs?.key) {
                    setFilteredTabs(prev => {
                        if (displayName && data?.["isDisplay"] === 0) {
                            delete prev?.[tabsDisplayNameMapping?.[displayName]];
                        }
                        updateCurrentTabOnFilteredTabs({
                            filteredTabsData: prev || {}
                        })
                        return prev;
                    })
                }
            }
        }
    }, [generalStore?.getHeadersData?.isSuccess]);

    // Functon : To update the current tab based on the updated filtered tabs
    const updateCurrentTabOnFilteredTabs = ({
        filteredTabsData = filteredTabs,
    }) => {
        let filterTab = JSON.parse(JSON.stringify(filteredTabsData));
        if (props?.actionBarConfig?.tabs && Object.keys(filterTab)?.length !== 0) {
            let tabkey = props?.actionBarConfig?.tabs?.key;
            let payloadVal = props.tableDataPayload?.[tabkey];

            if (!filterTab?.[payloadVal]) {
                let payloadVal = Object.keys(filterTab)[0];
                props?.actionBarConfig?.tabs?.onChange(payloadVal)();
            }
        }
    }

    // Enable expand all functionality for the pages 
    useEffect(() => {

        if (Object.keys(expandAll || {})?.length > 0) {
            if (expandAll?.index == expandAll?.data?.length) {
                setExpandAll({});
            } else {
                setTimeout(() => {
                    expandRow(expandAll?.data?.[expandAll?.index])();
                    setExpandAll(prev => ({
                        ...prev,
                        index: prev.index + 1,
                        currentTab: currentTab,
                    }))
                }, expandAll?.index == 0 ? 0 : 500)
            }
        }

    }, [expandAll])

    useEffect(() => {
        // See if the current tab is changed or not!
        resetExpandedData();
        setHeadersData({});
        setHeadersType({});
    }, [props.currentTab])

    const resetExpandedData = () => {
        setMainExpandedRow({});
        setMainExpandedData({})
        setItemExpandedData({})
        setItemExpandedRow({})
        setMainExpandLoading({});
        setItemExpandLoading({});
        setExpandAll({});
    }

    const expandAllRows = (config) => {
        let { tableData = [] } = config;
        setExpandAll({
            index: 0,
            data: tableData,
            currentTab: currentTab
        })
    }

    // Close the expanded row when the usern wants;
    useEffect(() => {
        if (expandFirstProps?.closeFirstExpandedRow) {
            resetExpandedData();
        }
    }, [expandFirstProps?.closeFirstExpandedRow])

    useLayoutEffect(() => {
        if (generalStore?.["getTableComponentSecondListData"]?.isSuccess) {
            let data = generalStore?.["getTableComponentSecondListData"]?.data;
            let uniqueId = generalStore?.["getTableComponentSecondListData"]?.data?.uniqueExpandId;
            if (mainExpandedRow && uniqueId) {
                let listData = props?.getExpandFirstListData ? props.getExpandFirstListData(data, {
                    mainExpandedRow: mainExpandedRow?.[uniqueId] || {},
                }) : data?.resource || [];
                setMainExpandedData(updatedMainExpandedData => {
                    updatedMainExpandedData[uniqueId] = listData;
                    return updatedMainExpandedData;
                })
            }
            setMainExpandLoading(updatedMainExpandLoading => {
                delete updatedMainExpandLoading?.[uniqueId];
                return updatedMainExpandLoading;
            })
        }
        if (generalStore?.["getTableComponentSecondListData"]?.isError) {
            let uniqueId = generalStore?.["getTableComponentSecondListData"]?.data?.uniqueExpandId;
            setMainExpandLoading(updatedMainExpandLoading => {
                delete updatedMainExpandLoading?.[uniqueId];
                return updatedMainExpandLoading;
            })
        }
    }, [generalStore?.["getTableComponentSecondListData"]])

    useEffect(() => {
        if (generalStore?.["getTableComponentThirdListData"]?.isSuccess) {
            let uniqueId = generalStore?.["getTableComponentThirdListData"]?.data?.uniqueExpandId;
            let uniqueId1 = uniqueId?.split(',')?.[1];
            let uniqueId2 = uniqueId?.split(',')?.[0];
            let data = generalStore?.["getTableComponentThirdListData"]?.data;
            let listData = props?.getExpandSecondListData ? props.getExpandSecondListData(data) : data?.resource || [];
            let updatedItemExpandedData = { ...itemExpandedData };
            if (itemExpandedRow?.[uniqueId2]?.[uniqueId1]) {
                if (!updatedItemExpandedData?.[uniqueId2]) {
                    updatedItemExpandedData[uniqueId2] = {};
                }
                updatedItemExpandedData[uniqueId2][uniqueId1] = listData;
                setItemExpandedData(updatedItemExpandedData)
            }

            let updatedItemExpandLoading = { ...itemExpandLoading };
            delete updatedItemExpandLoading?.[uniqueId2]?.[uniqueId1];
            setItemExpandLoading(updatedItemExpandLoading);
        }
        if (generalStore?.["getTableComponentThirdListData"]?.isError) {
            let uniqueId = generalStore?.["getTableComponentThirdListData"]?.data?.uniqueExpandId;
            let uniqueId1 = uniqueId?.split(',')?.[1];
            let uniqueId2 = uniqueId?.split(',')?.[0];
            let updatedItemExpandLoading = { ...itemExpandLoading };
            delete updatedItemExpandLoading?.[uniqueId2]?.[uniqueId1];
            setItemExpandLoading(updatedItemExpandLoading);
        }
    }, [generalStore?.["getTableComponentThirdListData"]])

    const changeTab = (tab) => () => {
        props?.setCurrentTab?.(tab);
    }


    const expandRow = (item) => e => {
        if (props.getExpandFirstPayload) {
            let updatedMainExpandedRow = { ...mainExpandedRow };
            let updatedMainExpandedData = { ...mainExpandedData }
            let updatedItemExpandedRow = { ...itemExpandedRow };
            let updatedItemExpandedData = { ...itemExpandedData };

            delete updatedItemExpandedRow?.[item?.id];
            delete updatedItemExpandedData?.[item?.id];

            if (!mainExpandedRow?.[item?.id]) {
                let payload = props?.getExpandFirstPayload(item);
                if (displayNamesForNewSubmitApi?.[getTableHeadersPayload?.()?.main?.key]) {
                    payload["displayName"] = getTableHeadersPayload?.()?.[typeof (props?.expandFirstKey) == "function" ? props?.expandFirstKey?.(item || {}) : props.expandFirstKey]?.["key"];
                }
                let expandFirstRowItem = props.getExpandFirstRowItem ? props.getExpandFirstRowItem({ item }) : item;
                updatedMainExpandedRow[item?.id] = expandFirstRowItem;
                dispatchHandler(dispatch, "getTableComponentSecondListRequest", { ...payload, uniqueExpandId: item?.id }, props?.getExpandFirstExtraHeaders);
                let updatedMainExpandLoading = { ...mainExpandLoading };
                updatedMainExpandLoading[item.id] = true;
                setMainExpandLoading(updatedMainExpandLoading);
                let updatedItemExpandLoading = { ...itemExpandLoading };
                delete updatedItemExpandLoading?.[item.id];
                setItemExpandLoading(updatedItemExpandLoading)
            }
            else {
                delete updatedMainExpandedRow?.[item?.id];
            }
            setMainExpandedRow(updatedMainExpandedRow);
            setMainExpandedData(updatedMainExpandedData)
            setItemExpandedData(updatedItemExpandedData)
            setItemExpandedRow(updatedItemExpandedRow)
        }
    }

    const expandSetRow = (item, mainRowItem) => () => {
        if (props.getExpandSecondPayload) {

            let updatedItemExpandedData = { ...itemExpandedData };
            let updatedItemExpandedRow = { ...itemExpandedRow };
            delete updatedItemExpandedData?.[mainRowItem?.id]?.[item?.id];

            if (!itemExpandedRow?.[mainRowItem?.id]?.[item?.id]) {
                let payload = props?.getExpandSecondPayload(item, mainExpandedRow?.[mainRowItem?.id]);
                if (displayNamesForNewSubmitApi?.[getTableHeadersPayload?.()?.main?.key]) {
                    payload["displayName"] = getTableHeadersPayload?.()?.[[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(item, mainExpandedRow?.[mainRowItem?.id] || {}) : props.expandSecondKey]]?.["key"];
                }
                dispatchHandler(dispatch, "getTableComponentThirdListRequest", { ...payload, uniqueExpandId: `${mainRowItem?.id},${item?.id}` }, props?.getExpandSecondExtraHeaders);
                if (!updatedItemExpandedRow?.[mainRowItem?.id]) {
                    updatedItemExpandedRow[mainRowItem.id] = {};
                }
                let updatedItemExpandLoading = { ...itemExpandLoading };
                if (!updatedItemExpandLoading?.[mainRowItem?.id]) {
                    updatedItemExpandLoading[mainRowItem.id] = {};
                }
                updatedItemExpandLoading[mainRowItem.id][item.id] = true;
                updatedItemExpandedRow[mainRowItem.id][item.id] = item;
                setItemExpandLoading(updatedItemExpandLoading);

            }
            else {
                delete updatedItemExpandedRow?.[mainRowItem?.id]?.[item?.id];
                if (Object.keys(updatedItemExpandedRow?.[mainRowItem?.id] || {})?.length == 0) {
                    delete updatedItemExpandedRow?.[mainRowItem?.id];
                }
            }
            setItemExpandedData(updatedItemExpandedData)
            setItemExpandedRow(updatedItemExpandedRow)
        }
    }

    const getExpandedData = (type, item) => {
        switch (type) {
            case "main": return mainExpandedData?.[item?.id];
        }
    }

    // Function : To get the headers and the 
    const getTableHeadersMap = () => {
        return isNewMenuEnabled?.() ? tableHeadersMap : props.tableHeadersMap;
    }

    // Function : to get the table headers payload
    const getTableHeadersPayload = () => {
        return isNewMenuEnabled?.() ? Object.keys(filteredTabs || {})?.length > 1 ? tableHeadersMap?.[currentTab] || {} : tableHeadersMap || {} : props?.tableHeadersPayload || {}
    }

    const getPayload = () => {
        if (isNewMenuEnabled?.()) {
            let payload = props.tableDataPayload || {
                type: 1,
                pageNo: 1,
                sortedBy: "",
                sortedIn: "",
                search: "",
                filter: {},
                pageSize: 10,
                apiUrl: (typeof (props.apiUrl) == "function" ? props.apiUrl?.() || undefined : props.apiUrl) || undefined,
                doamin: props.domain || undefined,
                baseUrl: props.baseUrl || undefined,
                summaryApiUrl: props.summaryApiUrl || undefined,
                isChangeSummaryBaseUrl: props?.isChangeSummaryBaseUrl || undefined,
                summaryApiBaseUrl: props?.summaryApiBaseUrl || undefined
            }
            if (!props.customConfig?.dontUpdateApiUrl)
                payload.apiUrl = Object.keys(filteredTabs || {})?.length > 1 ? getTableHeadersMap?.()?.[currentTab]?.["main"]?.["apiUrl"] : getTableHeadersMap?.()?.["main"]?.["apiUrl"];
            return payload;
        } else {
            return props.tableDataPayload || {
                type: 1,
                pageNo: 1,
                sortedBy: "",
                sortedIn: "",
                search: "",
                filter: {},
                pageSize: 10,
                apiUrl: (typeof (props.apiUrl) == "function" ? props.apiUrl?.() || undefined : props.apiUrl) || undefined,
                doamin: props.domain || undefined,
                baseUrl: props.baseUrl || undefined,
                summaryApiUrl: props.summaryApiUrl || undefined,
            }
        }
    }

    // function : to get the tabs data
    const getTabs = () => {
        return props?.actionBarConfig?.tabsKey ? {
            key: props?.actionBarConfig?.tabsKey || "status",
            data: filteredTabs || {},
            onChange: changeTab
        } : props?.actionBarConfig?.tabs ? {
            key: props?.actionBarConfig?.tabs?.key,
            data: filteredTabs,
            onChange: props?.actionBarConfig?.tabs?.onChange
        } : false
    }


    // Function : To get the download report changes
    const getDownloadReport = () => {
        if (props.actionBarConfig?.isItemAvailable) {
            return {
                downloadReport: {
                    headerLevelModule: getTableHeadersPayload?.()?.main?.key,
                    detailLevelModule: props.actionBarConfig?.isCustomDetailModule?.detailLevelModule ?? Object.values(getTableHeadersPayload?.() || {})?.map(item => item?.key)?.join(),
                    detailHeadersData: props.actionBarConfig?.isCustomDetailModule?.detailHeadersData ?? Object.values(headersData || {}),
                    detailHeadersType: props.actionBarConfig?.isCustomDetailModule?.detailHeadersType ?? Object.values(headersType),
                    tableHeadersMap: getTableHeadersPayload?.()
                }
            }
        } else if (props.actionBarConfig?.downloadReport) {
            return {
                downloadReport: {
                    headerLevelModule: getTableHeadersPayload?.()?.main?.key,
                    tableHeadersMap: getTableHeadersPayload?.()
                },
            }
        } return false;
    }

    useEffect(() => {
        if(states?.[storeName]?.[`${apiName}Data`]?.isSuccess) {
            resetExpandedData();
        }
    }, [states?.[storeName]?.[`${apiName}Data`]?.isSuccess])

    // Required Props = :
    // downloadReport -> If available then this is always required component
    let Component = (
        <React.Fragment>
            {
                useRenderClassComponent(TableComponent, {
                    braedCrumps: props.braedCrumps,
                    downloadReportName: props.page == "POGRNREPORT" ? true : false,
                    actionBarConfig: {
                        search: {
                            disabled: false
                        },
                        quickFilter: {
                            disabled: generalStore?.getQuickFiltersData?.isLoading
                        },
                        emailReport: {
                            disabled: false
                        },
                        downloadReport: props?.actionBarConfig?.isItemAvailable ? {
                            headerLevelModule: getTableHeadersPayload?.()?.main?.key,
                            detailLevelModule: Object.values(getTableHeadersPayload?.() || {})?.map(item => item?.key)?.join(),
                            detailHeadersData: Object.values(headersData || {}),
                            detailHeadersType: Object.values(headersType),
                            tableHeadersMap: getTableHeadersPayload?.()
                        } : false,
                        sorting: {
                            disabled: generalStore?.getHeadersData?.isLoading
                        },
                        filters: {
                            disabled: generalStore?.getHeadersData?.isLoading,
                        },
                        ...props.actionBarConfig,
                        tabs: getTabs(),
                        ...(isNewMenuEnabled?.() ? getDownloadReport() : {}),
                    },
                    tableConfig: {
                        columnSetting: {
                            disabled: generalStore?.getHeadersData?.isLoading || generalStore?.createHeadersData?.isLoading
                        },
                        expand: (item) => props.expandFirstKey ? {
                            expandedData: getExpandedData("main", item) || [],
                            disabled: false,
                            expandedRow: mainExpandedRow,
                            headersData: (props?.expandSecondKey ? props.isMultipleLevelAvailable?.(mainExpandedRow?.[item?.id] || {}) : true) ? headersData?.[typeof (props?.expandFirstKey) == "function" ? props?.expandFirstKey?.(mainExpandedRow?.[item?.id] || {}) : props.expandFirstKey] : headersData?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(mainExpandedRow?.[item?.id] || {}, mainExpandedRow?.[item?.id] || {}) : props.expandSecondKey],
                            headersType: (props?.expandSecondKey ? props.isMultipleLevelAvailable?.(mainExpandedRow?.[item?.id] || {}) : true) ? headersType?.[typeof (props?.expandFirstKey) == "function" ? props?.expandFirstKey?.(mainExpandedRow?.[item?.id] || {}) : props.expandFirstKey] : headersType?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(mainExpandedRow?.[item?.id] || {}, mainExpandedRow?.[item?.id] || {}) : props.expandSecondKey],
                            isLoading: generalStore?.["getTableComponentSecondListData"]?.isLoading && (mainExpandLoading?.[item?.id]),
                            onClick: expandRow,

                            expand: (subItem) => Object.keys(mainExpandedRow?.[item?.id] || {})?.length > 0 && (props.isMultipleLevelAvailable?.(mainExpandedRow?.[item?.id] || {}) || false) ? {
                                expandedData: itemExpandedData?.[item?.id]?.[subItem?.id] || [],
                                expandedRow: itemExpandedRow?.[item?.id] || {},
                                headersData: headersData?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(itemExpandedRow?.[item?.id]?.[subItem?.id] || {}, mainExpandedRow?.[item?.id] || {}) : props.expandSecondKey],
                                headersType: headersType?.[typeof (props?.expandSecondKey) == "function" ? props.expandSecondKey(itemExpandedRow?.[item?.id]?.[subItem?.id] || {}, mainExpandedRow?.[item?.id] || {}) : props.expandSecondKey],
                                isLoading: generalStore?.["getTableComponentThirdListData"]?.isLoading && (itemExpandLoading?.[item?.id]?.[subItem?.id]),
                                onClick: (subItem) => expandSetRow?.(subItem, item)
                            } : false,

                            ...(typeof (expandFirstProps) == "function" ? expandFirstProps({ expandedRow: mainExpandedRow?.[item?.id] }) : expandFirstProps || {})
                        } : false,
                        ...props.tableConfig,
                    },
                    collapseAll: Object.keys(expandAll || {})?.length > 0 ? false : {
                        onClick: () => resetExpandedData(),
                        isCollapseAllOpen: () => Object.keys(mainExpandedRow || {})?.length > 0,
                    },
                    expandAll: props.expandAll && props.expandFirstKey && !(Object.keys(expandAll || {})?.length > 0) ? {
                        onClick: (config) => expandAllRows(config),
                        isExpandAllRunning: () => Object.keys(expandAll || {})?.length > 0,
                    } : false,
                    tableHeadersPayload: getTableHeadersPayload?.(),
                    quickFiltersPayload: {
                        attributeType: getTableHeadersPayload?.()?.main?.key,
                        displayName: getTableHeadersPayload?.()?.main?.key,
                        filterName: ""
                    },
                    tableDataPayload: getPayload(),
                    summaryRequest: (props.tableDataPayload?.summaryApiUrl || props.summaryApiUrl) ? `${summaryApiName}Request` : false,
                    getTableDataRequest: props.getTableDataRequest ? props.getTableDataRequest : `${apiName}Request` || "",
                    getTableDataLoading: props.getTableDataLoading ? props.getTableDataLoading : states?.[storeName]?.[`${apiName}Data`]?.isLoading,
                    getTableDataSuccess: props.getTableDataSuccess ? props.getTableDataSuccess : states?.[storeName]?.[`${apiName}Data`]?.isSuccess,
                    getTableDataError: props.getTableDataError ? props.getTableDataError : states?.[storeName]?.[`${apiName}Data`]?.isError,
                    tableData: props?.tableData ? props.tableData : states?.[storeName]?.[`${apiName}Data`]?.data ?
                        {
                            data: states?.[storeName]?.[`${apiName}Data`]?.data?.resource || [],
                            totalItems: states?.[storeName]?.[`${apiName}Data`]?.data?.[props.totalRecordKey || "totalCount"] || 0,
                            currentPage: states?.[storeName]?.[`${apiName}Data`]?.data?.currPage || 1,
                            maxPage: states?.[storeName]?.[`${apiName}Data`]?.data?.maxPage || 1,
                            getTableApiData: states?.[storeName]?.[`${apiName}Data`]?.data || []
                        } :
                        {
                            data: [],
                            totalItems: 0,
                            currentPage: 1,
                            maxPage: 1
                        },
                    refreshData: props.refreshData || false,
                    confirmationLoading: props.confirmationLoading || false,
                    customAction: props.customAction || false,
                    resetstate: props.resetstate,
                    tableDataPayloadUpdated: props.tableDataPayloadUpdated,
                    ref: props.tableComponentRef || null,
                    imageOrderNumber: props.imageOrderNumber,
                    breadCrumbsProps: props.breadCrumbsProps,
                    viewType: props?.viewType || "list",
                    tableComExtraHeaders: props?.tableComExtraHeaders || null,
                    tableSummaryHeaders: props?.tableSummaryHeaders || null,
                    hidePaginationDropdown: props.hidePaginationDropdown,
                    downloadReportColumnName: props?.downloadReportColumnName,

                    documentViewerConfig: props.documentViewerConfig || null,
                    headersDataRef : props.headersDataRef,

                    // Props for Document Viewer : To create and customize the expand functionality in the Document Viewer
                    getExpandFirstPayload: props.getExpandFirstPayload || null,
                    expandFirstKey: props.expandFirstKey || null,
                    getExpandFirstListData: props.getExpandFirstListData || null,
                    getExpandSecondPayload: props.getExpandSecondPayload || null,
                    expandSecondKey: props.expandSecondKey || null,
                    getExpandSecondListData: props.getExpandSecondListData,
                    isMultipleLevelAvailable: props.isMultipleLevelAvailable,
                    getGridConfig: props.getGridConfig || null,
                    paginationLeftExtras: props.paginationLeftExtras || null,
                    renderCustomTable: props.renderCustomTable || null,
                    hidePaginationAndSearch: props.hidePaginationAndSearch || false,
                    hideThreeDots: props.hideThreeDots || false,
                    preserveFilterKeys: props.preserveFilterKeys || props.customConfig?.preserveFilterKeys || props.preserveFilters || [],
                    customConfig: props.customConfig
                },
                    props.availableStores)
            }
        </React.Fragment>
    )

    if (tabsLoading) {
        return <TableFullPageLoader />
    }

    if (isNewMenuEnabled?.()) {
        if (Object.keys(filteredTabs || {})?.length == 0) return <NoPageAvailable />
    } else {
        if (props?.actionBarConfig?.tabs?.key ? Object.keys(filteredTabs)?.length == 0 : getTableHeadersMap?.() ? headersResponse?.[typeof (getTableHeadersMap?.()) == "function" ? getTableHeadersMap?.()?.()?.main?.key : getTableHeadersMap?.()?.main?.key] != 1 : false) {
            return <NoPageAvailable />
        }
    }

    return Component;

}